<template>
  <v-container>
    <v-row>
      <v-col cols='3'>
        <div class="caption grey--text font-italic mr-1">Filter by:</div>
        <staging-table-icon icon='mdi-timer-outline' icon_active='mdi-timer' active_color="primary"
          @filter='filterQuickPay' text="Quickpay" />
        <staging-table-icon icon='mdi-snail' icon_active='mdi-snail' active_color="primary"
          @filter='filterSnailMailOnly' text="Snail mail only" />
        <staging-table-icon icon='mdi-alert-circle-outline' icon_active='mdi-alert-circle' active_color="primary"
          @filter='filterConflicts' text="Conflicts" />
        <template v-if='disable_timeline_filter === false'>
          <staging-table-icon icon='mdi-alert-octagon-outline' icon_active='mdi-alert-octagon' active_color="primary"
            @filter='toggleConflictChoiceOpen' text="Specific Conflict" />
        </template>
        <staging-table-icon icon='mdi-close-circle-outline' icon_active='mdi-close-circle' active_color="primary"
          @filter='filterSeriousConflicts' text="Serious Conflicts" />
        <staging-table-icon icon='mdi-help-rhombus-outline' icon_active='mdi-help-rhombus' active_color="primary"
          @filter='filterPreCheckRequired' text="Pre-checkRequired" />
        <staging-table-icon icon='mdi-checkbox-marked-circle-outline' icon_active='mdi-checkbox-marked-circle'
          active_color="primary" @filter='filterNoConflicts' text="No Conflicts" />
        <staging-table-icon icon='mdi-text-box-outline' icon_active='mdi-text-box' active_color="primary"
          @filter='filterInProgress' text='In Progress' />
        <template v-if='disable_meter_pits_filter === false'>
          <staging-table-icon icon='mdi-camera-metering-matrix' icon_active='mdi-camera-metering-matrix'
            active_color="primary" @filter='filterMeterPits' text="Meter Pits" />
        </template>
        <template v-if='disable_po_filter === false'>
          <staging-table-icon icon='mdi-alpha-p-circle-outline' icon_active='mdi-alpha-p-circle' active_color="primary"
            @filter='filterPO' text="Requires PO" />
        </template>
        <template v-if='disable_commercial_filter === false'>
          <staging-table-icon icon='mdi-domain' icon_active='mdi-domain' active_color="primary"
            @filter='filterCommercial' text="Commercial" />
        </template>
        <template v-if='disable_timeline_filter === false'>
          <staging-table-icon icon='mdi-alpha-t-box-outline' icon_active='mdi-alpha-t-box' active_color="primary"
            @filter='filterTimeline' text="Timeline" />
        </template>
        <template v-if="conflict_choice_open">
          <v-combobox v-model='selections' :items='conflict_choices' label='Filter conflicts with all of:'
            item-text="title" item-value="value" small-chips clearable></v-combobox>
          <v-btn text small color='info' @click="filterConflictChoices">
            Filter
          </v-btn>
        </template>
        <div class='subtitle-2'>
          Projects
        </div>
        <div style="font-size: 11px; color: black; text-align: start; margin-top: -2px;">
          <span>
            {{ projectNumber + " total" }}
          </span>
          <span class='ml-1 orange--text text--darken-4'>
            {{ totalConflicts + " conflicts" }}
          </span>
          <span class='ml-1 red--text text--darken-2'>
            {{ totalFatalConflicts + " fatal conflicts" }}
          </span>
        </div>
      </v-col>
      <v-col>
        <div class="caption grey--text font-italic mr-1">&nbsp;</div>
        <div class='d-flex justify-center'>
          <staging-table-icon icon='mdi-filter-outline' icon_active='mdi-filter' active_color="primary"
            @filter='filterColumnOne' text='Filter Column' />
        </div>
        <div class="subtitle-2 text-center">
          {{ first_column }}
        </div>
        <div class="text-center" style="font-size: 11px;">
          {{ stats.stage_1 }}
        </div>
      </v-col>
      <v-col>
        <div class="caption grey--text font-italic mr-1">&nbsp;</div>
        <div class='d-flex justify-center'>
          <staging-table-icon icon='mdi-filter-outline' icon_active='mdi-filter' active_color="primary"
            @filter='filterColumnTwo' text='Filter Column' />
        </div>
        <div class="subtitle-2 text-center">
          {{ second_column }}
        </div>
        <div class="text-center" style="font-size: 11px;">
          {{ stats.stage_2 }}
        </div>
      </v-col>
      <v-col>
        <div class="caption grey--text font-italic mr-1">&nbsp;</div>
        <div class='d-flex justify-center'>
          <staging-table-icon icon='mdi-filter-outline' icon_active='mdi-filter' active_color="primary"
            @filter='filterColumnThree' text='Filter Column' />
        </div>
        <div class="subtitle-2 text-center">
          {{ third_column }}
        </div>
        <div class="text-center" style="font-size: 11px;">
          {{ stats.stage_3 }}
        </div>
      </v-col>
      <v-col>
        <div class="caption grey--text font-italic mr-1">&nbsp;</div>
        <div class='d-flex justify-center'>
          <staging-table-icon icon='mdi-filter-outline' icon_active='mdi-filter' active_color="primary"
            @filter='filterColumnFour' text='Filter Column' />
        </div>
        <div class="subtitle-2 text-center">
          {{ fourth_column }}
        </div>
        <div class="text-center" style="font-size: 11px;">
          {{ stats.stage_4 }}
        </div>
      </v-col>
      <v-col v-if="fifth_column">
        <div class="caption grey--text font-italic mr-1">&nbsp;</div>
        <div class='d-flex justify-center'>
          <staging-table-icon icon='mdi-filter-outline' icon_active='mdi-filter' active_color="primary"
            @filter='filterColumnFive' text='Filter Column' />
        </div>
        <div class="subtitle-2 text-center">
          {{ fifth_column }}
        </div>
        <div class="text-center" style="font-size: 11px;">
          {{ stats.stage_5 }}
        </div>
      </v-col>
      <v-col>
        <div class="caption grey--text font-italic mr-1">&nbsp;</div>
        <div class='d-flex justify-center'>
          <staging-table-icon icon='mdi-filter-outline' icon_active='mdi-filter' active_color="primary"
            @filter='filterDeclined' text='Filter Column' />
        </div>
        <div class="subtitle-2 text-center">
          Cancelled/Declined
        </div>
        <div class="text-center" style="font-size: 11px;">
          {{ stats.cancelled }}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Icon from './Icon';

export default {
  name: 'staging-table-header',
  props: {
    loading: {
      required: false,
      type: Boolean,
      default: false
    },
    table_title: {
      required: true,
      type: String
    },
    table_icon: {
      required: true,
      type: String
    },
    length: {
      required: false,
      type: Number
    },
    stats: {
      required: true,
      type: Object
    },
    disable_po_filter: {
      required: false,
      type: Boolean,
      default: false
    },
    disable_timeline_filter: {
      required: false,
      type: Boolean,
      default: false
    },
    disable_commercial_filter: {
      required: false,
      type: Boolean,
      default: false
    },
    disable_meter_pits_filter: {
      required: false,
      type: Boolean,
      default: false
    },
    column_headers: {
      required: true,
      type: Array
    }
  },
  data: () => ({
    conflict_choice_open: false,
    selections: [],
    conflict_choices: [
      {
        "title": "Site Address Missing",
        "value": "site_address_missing=true&"
      },
      {
        "title": "Site City Missing",
        "value": "site_city_missing=true&"
      },
      {
        "title": "Site Province Missing",
        "value": "site_province_missing=true&"
      },
      {
        "title": "Site Postal Code Missing",
        "value": "site_postal_code_missing=true&"
      },
      {
        "title": "Route Group Missing",
        "value": "route_group_missing=true&"
      },
      {
        "title": "Route Number Missing",
        "value": "route_number_missing=true&"
      },
      {
        "title": "Project On Hold",
        "value": "project_on_hold=true&"
      },
      {
        "title": "Overdue Invoices",
        "value": "filter_overdue=true&"
      },
      {
        "title": "Notice Contact Missing",
        "value": "notice_contact_missing=true&"
      },
      {
        "title": "Mailing Address Missing",
        "value": "mailing_address_missing=true&"
      },
      {
        "title": "Email Address Missing",
        "value": "email_address_missing=true&"
      },
      {
        "title": "Notices Contact Archived",
        "value": "notices_contact_archived=true&"
      },
      {
        "title": "Notices Contact On Hold",
        "value": "notices_contact_on_hold=true&"
      },
      {
        "title": "Billing Contact Missing",
        "value": "billing_contact_missing=true&"
      },
      {
        "title": "Billing Address Missing",
        "value": "billing_address_missing=true&"
      },
      {
        "title": "Billing City Missing",
        "value": "billing_city_missing=true&"
      },
      {
        "title": "Billing Province Missing",
        "value": "billing_province_missing=true&"
      },
      {
        "title": "Billing Postal Missing",
        "value": "billing_postal_missing=true&"
      },
      {
        "title": "Billing Contact Archived",
        "value": "billing_contact_archived=true&"
      },
      {
        "title": "Billing Contact On Hold",
        "value": "billing_contact_on_hold=true&"
      },
      {
        "title": "No Work Required",
        "value": "no_work_required=true&"
      },
      {
        "title": "Asbuilt Missing",
        "value": "asbuilt_missing=true&"
      },
      {
        "title": "Install Date Missing",
        "value": "install_date_missing=true&"
      },
      {
        "title": "Number of Zones Missing",
        "value": "number_of_zones_missing=true&"
      },
      {
        "title": "Controller Type Missing",
        "value": "controller_type_missing=true&"
      },
      {
        "title": "Controller Location Missing",
        "value": "controller_location_missing=true&"
      },
      {
        "title": "Shut Off Location Missing",
        "value": "shut_off_location_missing=true&"
      },
      {
        "title": "Install Work Order Complete",
        "value": "install_work_order_complete=true&"
      },
      {
        "title": "Startup Price Missing",
        "value": "startup_price_missing=true&"
      },
      {
        "title": "Startup Time Missing",
        "value": "startup_time_missing=true&"
      },
      {
        "title": "Blowdown Price Missing",
        "value": "blowdown_price_missing=true&"
      },
      {
        "title": "Blowdown Time Missing",
        "value": "blowdown_time_missing=true&"
      },
      {
        "title": "Subd Tier Missing",
        "value": "subd_tier_missing=true&"
      },
      {
        "title": "Driveway Rating Missing",
        "value": "driveway_rating_missing=true&"
      },
      {
        "title": "Driveway Price Missing",
        "value": "driveway_price_missing=true&"
      }
    ]
  }),
  computed: {
    menu() {
      return true;
    },
    projectNumber() {
      return this.length;
    },
    totalConflicts() {
      return this.stats.conflicts;
    },
    totalFatalConflicts() {
      return this.stats.serious_conflicts;
    },
    first_column() {
      if (this.column_headers !== null && this.column_headers !== undefined && this.column_headers[0] !== null && this.column_headers[0] !== undefined) {
        return this.column_headers[0];
      } else {
        return 'Column 1';
      }
    },
    second_column() {
      if (this.column_headers !== null && this.column_headers !== undefined && this.column_headers[1] !== null && this.column_headers[1] !== undefined) {
        return this.column_headers[1];
      } else {
        return 'Column 2';
      }
    },
    third_column() {
      if (this.column_headers !== null && this.column_headers !== undefined && this.column_headers[2] !== null && this.column_headers[2] !== undefined) {
        return this.column_headers[2];
      } else {
        return 'Column 3';
      }
    },
    fourth_column() {
      if (this.column_headers !== null && this.column_headers !== undefined && this.column_headers[3] !== null && this.column_headers[3] !== undefined) {
        return this.column_headers[3];
      } else {
        return 'Column 4';
      }
    },
    fifth_column() {
      if (this.column_headers !== null && this.column_headers !== undefined && this.column_headers[4] !== null && this.column_headers[4] !== undefined) {
        return this.column_headers[4];
      }
      return null;
    }
  },
  methods: {
    toggleConflictChoiceOpen() {
      this.conflict_choice_open = !this.conflict_choice_open;
      if (!this.conflict_choice_open) {
        this.$emit("filterSpecificConflicts", "");
      }
    },
    filterConflictChoices() {
console.log("filter cconflict choice")
      if (this.selections.value) {
        this.$emit("filterSpecificConflicts", this.selections.value);
      }
      else {
        this.$emit("filterSpecificConflicts", "");
      }
    },
    filterConflicts(active) {
      this.$emit("filterConflicts", active);
    },
    filterSeriousConflicts(active) {
      this.$emit("filterSeriousConflicts", active);
    },
    filterNoConflicts(active) {
      this.$emit("filterNoConflicts", active);
    },
    filterPreCheckRequired(active) {
      this.$emit("filterPreCheckRequired", active);
    },
    filterQuickPay(active) {
      this.$emit("filterQuickPay", active);
    },
    filterSnailMailOnly(active) {
      this.$emit("filterSnailMailOnly", active);
    },
    filterColumnOne(active) {
      this.$emit("filterColumnOne", active);
    },
    filterColumnTwo(active) {
      this.$emit("filterColumnTwo", active);
    },
    filterColumnThree(active) {
      this.$emit("filterColumnThree", active);
    },
    filterColumnFour(active) {
      this.$emit("filterColumnFour", active);
    },
    filterColumnFive(active) {
      this.$emit("filterColumnFive", active);
    },
    filterDeclined(active) {
      this.$emit("filterDeclined", active);
    },
    filterInProgress(active) {
      this.$emit("filterInProgress", active);
    },
    filterMeterPits(active) {
      this.$emit("filterMeterPits", active);
    },
    filterCommercial(active) {
      this.$emit("filterCommercial", active);
    },
    filterPO(active) {
      this.$emit("filterPO", active);
    },
    filterTimeline(active) {
      this.$emit("filterTimeline", active);
    },
    filterNewHomeowner(active) {
      this.$emit("new_homeowner", active);
    },
    filterSiteAddressMissing(active) {
      this.$emit("site_address_missing", active);
    },
    filterSiteCityMissing(active) {
      this.$emit("site_city_missing", active);
    },
    filterSiteProvinceMissing(active) {
      this.$emit("site_province_missing", active);
    },
    filterPostalCodeMissing(active) {
      this.$emit("postal_code_missing", active);
    },
    filterRouteGroupMissing(active) {
      this.$emit("route_group_missing", active);
    },
    filterRouteNumberMissing(active) {
      this.$emit("route_number_missing", active);
    },
    filterProjectOnHold(active) {
      this.$emit("project_on_hold", active);
    },
    filterNoticeContactMissing(active) {
      this.$emit("notice_contact_missing", active);
    },
    filterMailingAddressMissing(active) {
      this.$emit("mailing_address_missing", active);
    },
    filterEmailAddressMissing(active) {
      this.$emit("email_address_missing", active);
    },
    filterNoticesContactArchived(active) {
      this.$emit("notices_contact_archived", active);
    },
    filterNoticesContactOnHold(active) {
      this.$emit("notices_contact_on_hold", active);
    },
    filterBillingContactMissing(active) {
      this.$emit("billing_contact_missing", active);
    },
    filterBillingAddressMissing(active) {
      this.$emit("billing_address_missing", active);
    },
    filterBillingCityMissing(active) {
      this.$emit("billing_city_missing", active);
    },
    filterBillingProvinceMissing(active) {
      this.$emit("billing_province_missing", active);
    },
    filterBillingPostalMissing(active) {
      this.$emit("billing_postal_missing", active);
    },
    filterBillingContactArchived(active) {
      this.$emit("billing_contact_archived", active);
    },
    filterBillingContactOnHold(active) {
      this.$emit("billing_contact_on_hold", active);
    }
  },
  components: {
    'staging-table-icon': Icon
  }
}
</script>
